import { PcComponent } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _PcComponentService {
  public getPcComponents(
    searchName = "",
    filterCategory = "",
    filterInStock = ""
  ) {
    return HttpService.get<PcComponent[]>("/pc-components", {
      queryParams: {
        searchName,
        filterCategory,
        filterInStock,
      },
    });
  }

  /** id các linh kiện user đã đăng ký "Báo khi có hàng" */
  public getMyNotify() {
    return HttpService.get<string[]>("/pc-components/notify/me");
  }

  /** Bật / tắt "Báo khi có hàng" */
  public toggleNotify(id: string) {
    return HttpService.post<{ subscribed: boolean }>(`/pc-components/${id}/notify`);
  }
}

const PcComponentService = new _PcComponentService();

export default PcComponentService;
